import { makeStyles, tokens } from '@fluentui/react-components';
import { fontScale } from '@/theme';

export const usePeriodComparisonStyles = makeStyles({
  root: {
    display: 'flex',
    flexDirection: 'column',
    gap: tokens.spacingVerticalM,
  },
  heading: {
    fontSize: fontScale.subtitle,
    fontWeight: tokens.fontWeightSemibold,
    color: tokens.colorNeutralForeground1,
    margin: 0,
  },
  tableWrapper: {
    width: '100%',
    overflowX: 'auto',
    WebkitOverflowScrolling: 'touch',
  },
  table: {
    width: '100%',
    borderCollapse: 'collapse',
    minWidth: '32rem',
  },
  th: {
    textAlign: 'start',
    padding: tokens.spacingVerticalS,
    fontSize: fontScale.caption,
    fontWeight: tokens.fontWeightSemibold,
    color: tokens.colorNeutralForeground3,
    borderBottom: `${tokens.strokeWidthThin} solid ${tokens.colorNeutralStroke2}`,
  },
  thNumeric: {
    textAlign: 'end',
  },
  td: {
    padding: tokens.spacingVerticalS,
    fontSize: fontScale.body,
    color: tokens.colorNeutralForeground1,
    borderBottom: `${tokens.strokeWidthThin} solid ${tokens.colorNeutralStroke3}`,
  },
  tdNumeric: {
    textAlign: 'end',
    fontVariantNumeric: 'tabular-nums',
  },
  metricName: {
    fontWeight: tokens.fontWeightSemibold,
  },
  deltaUp: {
    color: tokens.colorPaletteGreenForeground1,
  },
  deltaDown: {
    color: tokens.colorPaletteRedForeground1,
  },
  deltaFlat: {
    color: tokens.colorNeutralForeground3,
  },
});
